import { InlineValue, useContentSingletons, usePageContent, useXcoreUtils } from "@robe/client";
import { Container } from "@xcorejs/ui";
import RobeHeading from "design-system/robe/RobeHeading";
import { useRouter } from "next/router";
import type { ProductOverviewPage as ProductOverviewPageType, Products } from "xcore/types";
import ProductFilterView from "./ProductFilterView";
import ProductOverviewView from "./ProductOverviewView";

// Array of query params that are being used in product filtering, if other query params are provided app won't crash
const PRODUCT_FILTERS_QUERY_PARAMS = ["product-type", "product-size", "beam-type"];

const ProductOverview = () => {
  const { query } = useRouter();
  const { stringify, localize } = useXcoreUtils();
  const { values } = usePageContent<ProductOverviewPageType>();
  const [products] = useContentSingletons<[Products]>();
  const filters = resolveProductFiltersQueryParams(query);

  return (
    <Container flexDirection="column" paddingTop={{ _: "3rem", sm: "5rem" }} paddingBottom={{ _: "6rem", sm: "10rem" }}>
      <RobeHeading>
        <InlineValue value={localize(values?.title) ?? stringify(products.values.title)} />
      </RobeHeading>

      {Object.keys(filters).length === 0 ? <ProductOverviewView /> : <ProductFilterView filters={filters} />}
    </Container>
  );
};

export default ProductOverview;

const resolveProductFiltersQueryParams = (query: Record<string, string | string[] | undefined>) => {
  let productFilters: Record<string, string | string[]> = {};

  PRODUCT_FILTERS_QUERY_PARAMS.forEach((param) => {
    if (param in query && query[param] && param) {
      productFilters = {
        ...productFilters,
        [param]: query[param] as string | string[],
      };
    }
  });

  return productFilters;
};
